import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M8.75 3a.75.75 0 0 0-1.5 0v.25H6A3.75 3.75 0 0 0 2.25 7v11A3.75 3.75 0 0 0 6 21.75h12A3.75 3.75 0 0 0 21.75 18V7A3.75 3.75 0 0 0 18 3.25h-1.25V3a.75.75 0 0 0-1.5 0v.25h-6.5V3Zm11.5 6.25V7A2.25 2.25 0 0 0 18 4.75h-1.25V7a.75.75 0 0 1-1.5 0V4.75h-6.5V7a.75.75 0 0 1-1.5 0V4.75H6A2.25 2.25 0 0 0 3.75 7v2.25h16.5Zm-16.5 1.5h16.5V18A2.25 2.25 0 0 1 18 20.25H6A2.25 2.25 0 0 1 3.75 18v-7.25Z"
      clipRule="evenodd"
    />
    <path fill="#F7A600" d="M18 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
  </svg>
);
export default SvgTwoColorCalendar;
